export function canCollide(item) {
  return !(item instanceof Phaser.Sprite) || item.alpha > 0;
}
